import React from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import Button from '@shape-construction/arch-ui/src/Button';
import InputTextArea from '@shape-construction/arch-ui/src/InputTextArea';
import Modal from '@shape-construction/arch-ui/src/Modal';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import { AppVersion } from './AppVersion';

export type CrashReportFormData = {
  description: string;
};

interface CrashReportProps {
  onClose: () => void;
  onSubmit: ({ description }: CrashReportFormData) => void;
}

const CrashReport: React.FC<CrashReportProps> = ({ onClose, onSubmit }) => {
  const { t } = useTranslation();
  const requiredFieldMessage = t('errors.requiredField');

  const crashReportSchema = Yup.object().shape({
    description: Yup.string().required(requiredFieldMessage),
  });

  const form = useForm<CrashReportFormData>({
    resolver: yupResolver(crashReportSchema),
    defaultValues: {
      description: '',
    },
  });

  const { register, handleSubmit } = form;

  const submitFeedback = (values: CrashReportFormData) => {
    const { description } = values;
    onSubmit({
      description: description,
    });
    handleCloseModal();
  };

  const handleCloseModal = () => {
    onClose();
  };

  return (
    <Modal.Root open onClose={handleCloseModal}>
      <Modal.Header onClose={handleCloseModal}>
        <Modal.Title>{t('crashReport.title')}</Modal.Title>
      </Modal.Header>

      <Modal.Content className="flex p-4">
        <form className="space-y-6" onSubmit={handleSubmit(submitFeedback)}>
          <InputTextArea
            data-hj-allow
            label={t('crashReport.description.label')}
            rows={6}
            {...register('description')}
          />
        </form>
        <div className="pt-8 pb-4">
          <AppVersion />
        </div>
      </Modal.Content>
      <Modal.Footer>
        <Button color="secondary" variant="outlined" size="md" onClick={handleCloseModal}>
          {t('crashReport.cancelCTA')}
        </Button>
        <Button color="primary" variant="contained" size="md" type="submit" onClick={handleSubmit(submitFeedback)}>
          {t('crashReport.submitCTA')}
        </Button>
      </Modal.Footer>
    </Modal.Root>
  );
};

export default CrashReport;
